import { createSlice } from '@reduxjs/toolkit'

type InitialStateT = {
  type: string
  isEdited: boolean
  isEditPage: boolean
  data: any
  lastEditTime: string
}

const initialState: InitialStateT = {
  isEdited: false,
  isEditPage: false,
  lastEditTime: '',
  data: {},
  type: '',
}

export const userSlice = createSlice({
  name: 'currentItem',
  initialState,
  reducers: {
    resetCurrent(state, action) {
      state.data = {}
      state.isEdited = false
      state.isEditPage = false
      return state
    },
    initCurrent: (state, action) => {
      // Создаем копию данных
      const data = {...action.payload.data || {}};
      
      // Проверяем и преобразуем мультиязычные поля
      // ['name', 'description', 'bibliography'].forEach(field => {
      //   if (data[field] && typeof data[field] === 'string') {
      //     // Если поле существует и является строкой, преобразуем его в объект
      //     data[field] = { en: data[field] };
      //   }
      // });
      
      state.data = data;
      state.type = action.payload.type;
      state.isEditPage = true;
      return state;
    },
    updateCurrent: (state, action) => {
      state.data = { ...state.data, ...action.payload }
      state.isEdited = true
      state.isEditPage = true
      state.lastEditTime = new Date().toString().slice(16, 21) || ''
      return state
    },
    updateCurrentAndReset: (state, action) => {
      state.data = { ...state.data, ...action.payload }
      state.isEdited = false
      state.isEditPage = true
      return state
    },
  },
})

export const {
  resetCurrent,
  updateCurrentAndReset,
  initCurrent,
  updateCurrent,
} = userSlice.actions

export default userSlice.reducer
